/*  index.tsx
	Entry point of the React application
	Renders the App component into the root DOM element
	Includes global styles and performance reporting
*/
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'common/services/apiFetch';
import { installNumberInputWheelGuard } from 'common/dom/numberInputWheel';
import { ToastProvider } from './common/context/ToastContext';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';

installNumberInputWheelGuard();

const rootElement = document.getElementById('root') as HTMLElement;
const apiBaseUrl = getApiBaseUrl();

if (!apiBaseUrl) {
	rootElement.textContent =
		'Configuration manquante : créez config.js à la racine du frontend (window.__CORELYS_CONFIG__.apiBaseUrl).';
} else {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<React.StrictMode>
			<ToastProvider>
				<App />
			</ToastProvider>
		</React.StrictMode>
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
